import React, {useEffect, useState} from 'react';
import './App.css';
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {createHashHistory} from "history";
import {Index} from "./routes/Index/Index";
import {HeaderNav} from "./components/HeaderNav/HeaderNav";
import {About} from "./routes/About/About";
import {News} from "./routes/News/News";
import {Contact} from "./routes/Contact/Contact";
import {Service} from "./routes/Service/Service";
import {Product} from "./routes/Product/Product";
import intl from 'react-intl-universal';
import {locales, LOCALES_STORE_KEY} from "./locales/config";



function App() {
    const history = createHashHistory();
    const [initDone, setInitDone] = useState(false);

    useEffect(() => {
        window.addEventListener('hashchange', () => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        });

        loadLocales();
    }, []);

    function loadLocales() {
        let currentLocale = intl.determineLocale({
            localStorageLocaleKey: LOCALES_STORE_KEY
        });

        intl.init({
            currentLocale,
            locales,
        })
            .then(() => {
                setInitDone(true);
            });
    }

    return (
        initDone &&
        <Router history={history}>
            <div className="App" id="global-wrapper">
                <HeaderNav/>
                <Switch>
                    <Route exact path="/" component={() => <Redirect to="/index"/>}/>
                    <Route path="/index" component={Index}/>
                    <Route path="/about" component={About}/>
                    <Route path="/product" component={Product}/>
                    <Route path="/news" component={News}/>
                    <Route path="/contact" component={Contact}/>
                    <Route path="/service" component={Service}/>
                </Switch>
            </div>
        </Router>
    );
}

export default App;
